import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { BookingsViewVersion2 } from 'views/bookings-v2/bookings-view';
import { BookingsViewLegacy } from './bookings-view-v1';

export const BookingsView = () => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <BookingsViewVersion2 />;
  }

  return <BookingsViewLegacy />;
};
